:host {
  display: block;
  font-family: system-ui, sans-serif;
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10000;

  --cp-color-green-hsl: 139.41deg 58.62% 54.51%;
  --cp-color-green: hsl(var(--cp-color-green-hsl));

  --cp-color-yellow-hsl: 49.32deg 100% 62.55%;
  --cp-color-yellow: hsl(var(--cp-color-yellow-hsl));

  --cp-color-purple-hsl: 274.88deg 70.49% 64.12%;
  --cp-color-purple: hsl(var(--cp-color-purple-hsl));

  --cp-color-red-hsl: 358.46deg 100% 61.76%;
  --cp-color-red: hsl(var(--cp-color-red-hsl));

  --cp-color-blue-hsl: 196.18deg 100% 52.75%;
  --cp-color-blue: hsl(var(--cp-color-blue-hsl));
}

.toggle-button {
  position: relative;
  width: 48px;
  height: 48px;
  padding: 12px;
  border: none;
  border-radius: 50%;
  background: conic-gradient(
    from var(--bg-angle, 0deg),
    var(--cp-color-yellow),
    var(--cp-color-green),
    var(--cp-color-blue),
    var(--cp-color-purple),
    var(--cp-color-yellow)
  );
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
  z-index: 1;

  &:hover,
  &:focus {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
  &:active {
    transform: scale(0.95);
  }
}

.controls-panel {
  position: absolute;
  top: 0;
  right: 0;
  padding: 60px 1rem 1rem 1rem;
  background: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 280px;
  max-width: 320px;
  max-height: calc(100dvh - 100px);
  overflow-y: auto;
  opacity: 0;
  transform: translateY(-10px);
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.controls-panel.open {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.controls {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.no-variables-warning {
  text-align: center;
  background: lightyellow;
  padding: 1rem;
  border-radius: 4px;
  font-size: 0.9rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.07);
}

.control-group {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 6px;

  &::before {
    content: attr(data-group);
    font-weight: 600;
    color: #333;
    font-family: "Monaco", "Courier New", monospace;
    font-size: 1rem;    
  }
}

.control-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;
}

.control-header {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  align-items: center;
}

.var-name {
  font-weight: 600;
  color: #333;
  font-family: "Monaco", "Courier New", monospace;
  font-size: 0.9rem;
}

.current-value {
  color: #666;
  font-size: 0.85rem;
  font-family: "Monaco", "Courier New", monospace;

  .control-container--color-modern & {
    position: absolute;
    bottom: 7px;
    z-index: 1;
    text-shadow: 0 1px 1px white;
    width: 100%;
    text-align: center;
    pointer-events: none;
  }
}

input[type="range"] {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: #ddd;
  outline: none;
  -webkit-appearance: none;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #4caf50;
  cursor: pointer;
  transition: background 0.15s ease;
}

input[type="range"]::-webkit-slider-thumb:hover {
  background: #45a049;
}

input[type="range"]::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #4caf50;
  cursor: pointer;
  border: none;
  transition: background 0.15s ease;
}

input[type="range"]::-moz-range-thumb:hover {
  background: #45a049;
}

input[type="color"] {
  width: 100%;
  height: 40px;
  border: 2px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  background: transparent;
}

input[type="color"]::-webkit-color-swatch-wrapper {
  padding: 0;
}

input[type="color"]::-webkit-color-swatch {
  border: none;
  border-radius: 2px;
}

color-input.modern-color-picker {
  box-sizing: border-box;
  display: block;
  inline-size: 100%;
  height: 34px;
  border: 2px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
  background: transparent;
  position: relative;
  padding: 2px;
}

color-input.modern-color-picker::part(chip) {
  inline-size: 100%;
  block-size: 100%;
  border-radius: 4px;
  border: 0;
}

color-input.modern-color-picker::part(trigger) {
  inline-size: 100%;
  block-size: 100%;
}

/* Hide the text input part */
color-input.modern-color-picker::part(input) {
  display: none;
}

::slotted(*) {
  margin: 0;
}
